import { Component } from "../../../components/base/Component";
import { ICfa } from "../../../models/ICfa";
import { ComponentFactory } from "../../../services/ComponentFactory";

export class ClassicContainer extends Component {
	childCount: number;
	constructor(element: HTMLElement, app: ICfa) {
		super(element, app);
		this.childCount = this.setChildCount();
		this.applyChildCountStyles();
	}

	setChildCount(): number {
		const count = this._element.childElementCount;

		this._element.setAttribute("data-child-count", count.toString());
		this._element.setAttribute("data-has-multiple", (count > 1).toString());

		return count;
	}

	applyChildCountStyles(): void {
		switch (this.childCount) {
			case 1:
				this._element.classList.remove("grid-layout");
				break;
		}
	}
}

ComponentFactory.registerComponent("classicContainer", ClassicContainer);
